/* import __COLOCATED_TEMPLATE__ from './signup-steps.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { inject as service } from '@ember/service';
import { USER } from 'sh-www/models/user';
import clsx from 'clsx';

const ACTIVE_CONNECTOR_SVG = htmlSafe(
  `<svg width="100%" height="2" viewBox="0 0 122 2" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
    <rect width="122" height="2" rx="1" fill="#6E6E6E"/>
  </svg>`,
);

const INACTIVE_CONNECTOR_SVG = htmlSafe(
  `<svg width="100%" height="2" viewBox="0 0 122 2" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
    <line stroke-dasharray="2, 4" x1="0" y1="1" x2="600" y2="1" style="stroke-width: 2px;" stroke="#6E6E6E"></line>
  </svg>`,
);

const SIGNUP_STEPS = {
  [USER.SELLER_SIGNUP_STEPS.BASIC_PROFILE]: 1,
  [USER.SELLER_SIGNUP_STEPS.EXTENDED_PROFILE]: 2,
  [USER.SELLER_SIGNUP_STEPS.WORK_SAMPLES]: 3,
  [USER.SELLER_SIGNUP_STEPS.DONE]: 4,
};

const iconClasses = (complete) => clsx(
  'signup-steps__step__icon',
  'material-icons',
  complete ? 'signup-steps__step__icon--complete': 'signup-steps__step__icon--active',
);

const textClasses = (complete) => clsx(
  'signup-steps__step__text',
  complete ? 'signup-steps__step__icon--complete': 'signup-steps__step__icon--active',
);

class SignupSteps extends Component {
  @service media;

  get signupStep() {
    return SIGNUP_STEPS[this.args.step] ?? 0;
  }

  get firstStepIcon() {
    return this.signupStep > 1 ? 'check' : 'person';
  }

  get secondStepIcon() {
    return this.signupStep > 2 ? 'check' : 'checklist';
  }

  get thirdStepIcon() {
    return this.signupStep > 3 ? 'check' : 'video_library';
  }

  get firstStepIconClasses() {
    return iconClasses(this.signupStep > 1);
  }

  get firstStepTextClasses() {
    return textClasses(this.signupStep > 1);
  }

  get secondStepIconClasses() {
    return iconClasses(this.signupStep > 2);
  }

  get secondStepTextClasses() {
    return textClasses(this.signupStep > 2);
  }

  get thirdStepIconClasses() {
    return iconClasses(this.signupStep > 3);
  }

  get thirdStepTextClasses() {
    return textClasses(this.signupStep > 3);
  }

  get firstConnector() {
    return this.signupStep > 1 ? ACTIVE_CONNECTOR_SVG : INACTIVE_CONNECTOR_SVG;
  }

  get secondConnector() {
    return this.signupStep > 2 ? ACTIVE_CONNECTOR_SVG : INACTIVE_CONNECTOR_SVG;
  }
}

export default SignupSteps;
